import React, { useContext, useEffect, useState } from "react";
import { AiOutlineLogin } from "react-icons/ai";
import styled from "styled-components";
import LoginForm from "../modules/authentication/LoginForm";
import { Outlet, useLocation } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import Modal from "./Modal";
import ButtonRound from "./ButtonRound";
import { useValidateWiMuleToken } from "../hooks/useValidateWiMuleToken";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10%;
  padding-bottom: 10rem;
  justify-content: center;
  height: 100%; // This takes the full height of the viewport
  text-align: center;
`;

const Image = styled.img`
  width: 60rem;
  height: auto;
  margin-bottom: 1rem; // Space between image and text
`;

const TextBox = styled.div`
  font-size: 2.4em;
  color: var(--color-grey-800); // Example color
`;

function GdprProtectedRoute() {
  const validateWiMuleToken = useValidateWiMuleToken();
  const { userDetails } = useContext(UserContext);
  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const isAuth1 = Boolean(userDetails.userWiMuleToken);
  const location = useLocation();

  useEffect(() => {
    const validateToken = async () => {
      try {
        const isValid = await validateWiMuleToken();
        setIsAuth(isValid);
      } catch (error) {
        console.error(error.message);
        setIsAuth(false);
      } finally {
        setIsLoading(false);
      }
    };

    validateToken();
  }, [validateWiMuleToken]);

  if (!isAuth) {
    return (
      <Container>
        <Image src="/images/NotAuthorized2.png" alt="Not GDPR Authorized" />
        <TextBox>SECURITY KEY REQUIRED</TextBox>
        <TextBox>PLEASE REFRESH LOGIN</TextBox>
        <Modal>
          <Modal.Open opens="login">
            <ButtonRound>
              <AiOutlineLogin />
            </ButtonRound>
          </Modal.Open>
          <Modal.Window name="login">
            <LoginForm redirectPath={location.pathname} />
          </Modal.Window>
        </Modal>
      </Container>
    );
  }

  return <Outlet />;
}

export default GdprProtectedRoute;
